import {
  stringValidator,
} from '../../../../../OUI/Inputs';

export const tAddIdValidator = stringValidator;
